// extracted by mini-css-extract-plugin
module.exports = {"flightSm":"flightSm-JZmou","flightSm_aircraft":"flightSm_aircraft-1Nk2c","flightSm__price":"flightSm__price-34xz_","flightSm__priceMoney":"flightSm__priceMoney-1W8yq"};